import React from "react";
import { Button, Flex } from "@chakra-ui/react";
import { gray500, green700, white } from "core/resources/theme/colors";
import useGetOcupacoes from "./useGetOcupacoes";

export type EnabledButtonsType = {
  soja: boolean;
  milho: boolean;
  algodao: boolean;
  amendoim: boolean;
};

interface ActionButtonProdutividadeProps {
  label: string;
  onClick?: (props?: number) => void;
  isActive: boolean;
  enabled: boolean;
}

interface ActionButtonsProdutividadeRowProps {
  actualFilter?: number;
  handleChangeCurrentFilter?: (props: number) => void;
  totalItems?: number;
  enabledButtons: EnabledButtonsType;
}

export const ActionButtonProdutividade = ({
  onClick,
  label,
  isActive,
  enabled,
}: ActionButtonProdutividadeProps) => {
  return (
    <Button
      bg={isActive ? green700 : white}
      rounded="full"
      fontSize={16}
      mr={2}
      borderWidth={isActive ? 0 : 1}
      onClick={() => onClick && onClick()}
      borderColor={gray500}
      color={isActive ? "white" : "gray"}
      disabled={!enabled}
      _hover={{
        opacity: 0.73,
      }}
    >
      {label}
    </Button>
  );
};

export const ActionButtonsProdutividadeRow = ({
  actualFilter,
  handleChangeCurrentFilter,
}: ActionButtonsProdutividadeRowProps) => {

  const { data } = useGetOcupacoes();

  return (
    <Flex>
      <ActionButtonProdutividade
        label="Todos"
        isActive={actualFilter === 0}
        onClick={() =>
          handleChangeCurrentFilter &&
          handleChangeCurrentFilter(0)
        }
        enabled={true}
      />

      {data?.map(item => (
        <ActionButtonProdutividade
          key={item.ocupacaoId}
          label={item.nome}
          isActive={actualFilter === Number(item.codigo)}
          onClick={() =>
            handleChangeCurrentFilter &&
            handleChangeCurrentFilter(Number(item.codigo))
          }
          enabled={true}
        />
      ))}
    </Flex>
  );
};
